export default "__VITE_ASSET__Ta7eE8ZJ__"